import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PersonSearchService } from '../_services/person-search.service';

@Component({
    selector: 'app-europe-access-document',
    templateUrl: './europe-access-document.component.html',
    styleUrls: ['./europe-access-document.component.scss'],
    standalone: false
})
export class EuropeAccessDocumentComponent implements OnInit {

  previewresumeurl: any = null;
  constructor(private personService: PersonSearchService, private sanitization: DomSanitizer) { }

  ngOnInit() {
    this.previewresumeurl = null
    this.personService.openEuDoc().subscribe((res: any) => {
      let apiresp = res;
      var file3 = new Blob([apiresp], { type: 'application/pdf' });
      this.previewresumeurl = (URL.createObjectURL(file3) + "#toolbar=0&navpanes=0&scrollbar=0");
    })
  }




}
